module.exports = __webpack_public_path__ + "img/am.0dc00578.svg";